import { useEffect, useState } from 'react';

const getDeviceFlags = (width) => {
  const isMobile = width <= 768;
  const isTablet = width > 768 && width <= 1024;
  const isDesktop = width > 1024;
  return { isMobile, isTablet, isDesktop };
};

export const useDeviceType = () => {
  const getWidth = () => (typeof window === 'undefined' ? 1024 : window.innerWidth);
  const [width, setWidth] = useState(getWidth());

  useEffect(() => {
    const handleResize = () => setWidth(getWidth());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { width, ...getDeviceFlags(width) };
};
